import styles from './Invoice.module.scss';
import clsx from 'clsx';
import { Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Invoice = ({ informations, handlePress, isMobile }) => {
  const { t } = useTranslation();
  if (!informations || !Object.values(informations).length) return null;

  const rows = Object.entries({
    address: Object.values(informations?.address || {})
      ?.filter((value) => !!value)
      .join(', '),
    phone: informations?.phone,
    email: informations?.email,
    name: informations?.name,
  }).filter(([, value]) => !!value);

  return (
    <div className={clsx(styles.informations, { [styles.informations_mobile]: isMobile })}>
      <div className={styles.informations_list}>
        {rows.map(([key, value]) => (
          <div className={styles.informations_information} key={key}>
            {value}
          </div>
        ))}
      </div>
      <button type="button" className={styles.informations_button} onClick={handlePress}>
        <Pencil size={16} strokeWidth={2.2} />
        {t('settings.payments.billingInfo.editBillingInfo')}
      </button>
    </div>
  );
};
